import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	portCodeList: [],
	countryList: [],
	euCountryList: [],
	euTerritoryList: [],
};

export const portCodesSlice = createSlice({
	name: "portCodes",
	initialState,
	reducers: {
		// For Ports
		fetchAllPortCodes: (state, action) => {
			state.portCodeList = action.payload;
		},
		savePortCode: (state, actions) => {
			state.portCodeList = [...state.portCodeList, actions.payload];
		},
		editPortCode: (state, actions) => {
			//
		},
		deletePortCode: (state, actions) => {
			actions.payload.forEach(function(item, index, array) {
        const portCodeIndex = state.portCodeList.findIndex(portCode => portCode.id === item.id);
        state.portCodeList.splice(portCodeIndex, 1);
    })
		},
		// For country
		saveCountry: (state, actions) => {
			//
		},
		editCountry: (state, actions) => {
			//
		},
		deleteCountry: (state, actions) => {
			//
		},
		// For EU Country
		saveEuCountry: (state, actions) => {
			//
		},
		editEuCountry: (state, actions) => {
			//
		},
		deleteEuCountry: (state, actions) => {
			//
		},
		// For EU Country
		saveEuTerritory: (state, actions) => {
			//
		},
		editEuTerritory: (state, actions) => {
			//
		},
		deleteEuTerritory: (state, actions) => {
			//
		},
	},
});

export const portCodesActions = portCodesSlice.actions;
export default portCodesSlice.reducer;
